import './App.css';
import Chat from "./components/Chat";

function App() {
  return (
    <div className="App">
    <h1>Chat application</h1>
        <Chat></Chat>
    </div>
  );
}

export default App;
